import { selectFolders } from '../../selectors/folders';
import { TThunkAction } from '../../types/redux';
import { DEFAULT_LIMIT, getFolders } from './getFolders';

export const refreshFolders = (): TThunkAction<void> => (dispatch, getState) => {
  const folders = selectFolders(getState());

  dispatch(getFolders({ limit: Math.max(folders.length, DEFAULT_LIMIT) }));
};
